if (!customElements.get('component-cart-drawer')) {
  customElements.define('component-cart-drawer', class CartDrawer extends HTMLElement {
    constructor() {
      super();

      this.headerCartBadge = document.querySelector('.js-header-cart-badge');
      this.cartDrawerBadge = document.querySelector('.js-cart-drawer-badge');

      this.settings = {
        startOpen: this.dataset.startOpen === 'true',
        startOpenDelay: +this.dataset.startOpenDelay || 500
      }

      this.setEventListeners();

      // Open the the cart on page load when startOpen setting is true
      if (this.settings.startOpen) {
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('open-cart-drawer'));
          window.localStorage.setItem('isCartDrawerOpen', true);
        }, this.settings.startOpenDelay);
      }
    }

    setEventListeners() {
      window.addEventListener('open-cart-drawer', () => {
        this.style.right = 0;
        window.dispatchEvent(new CustomEvent('show-overlay'));
        window.localStorage.setItem('isCartDrawerOpen', true);
      });

      window.addEventListener('close-cart-drawer', () => {
        this.style.right = '-100%';
        window.broadcastChannel.dispatchEvents(['hide-overlay', 'refresh-discount-input']);
        window.localStorage.setItem('isCartDrawerOpen', false);
      });

      window.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') {
          window.dispatchEvent(new CustomEvent('close-cart-drawer'));
        }
      });

      window.addEventListener('update-cart-badge', () => {
        if (!this.headerCartBadge || !this.cartDrawerBadge) return;
        const itemCount = window.cartManager.getLocalCart().item_count || '';
        this.headerCartBadge.textContent = itemCount;
        this.cartDrawerBadge.textContent = itemCount;
      });
    }
  });
}
